import '../base'; //Import template styles

import '../../styles/template/page.stockists.scss'; // Import scripts